<template>
  <div>
    <BaseTitle :title="$t('content.view_announcement')" :yearPeriode="titleData" />
    <v-card>
      <div>
        <v-card class="pa-5 d-flex justify-space-between align-items section-header active" flat tile>
          <div>
            <span class="student-title d-inline">{{ datas.title }}</span>
            <span class="student-content d-block">{{ datas.date }}</span>
          </div>
          <div>
            <span class="student-content"> By : </span><b class="student-content">{{ datas.by }}</b>
          </div>
        </v-card>
        <div class="border-item pa-8">
          <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
          <article v-if="datas.description" class="container mb-5" v-html="datas.description" />
          <span v-else>-</span>
        </div>
      </div>
    </v-card>
    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'StudentViewAnnouncement',
  components: {
    BaseTitle
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    isParent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      classLevel: 'QuizTeacher/classLevel',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    dataClass: '',
    datas: '',
    loadingLoad: false,
    titleData: ''
  }),
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Announcement/fetchDetail', this.$route.params.id)
        .then(res => {
          this.datas = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    back() {
      if (!this.isClass) {
        this.$router.push({ name: 'AnnouncementIndex' });
        return;
      }

      if (!this.isStudent) {
        const name = this.$route.params.classSectionId ? 'AnnouncementSectionIndexClass' : 'AnnouncementIndexClass';
        this.$router.push({ name });
        return;
      }

      const name = this.isParent ? 'AnnouncementParentIndexClass' : 'AnnouncementStudentIndexClass';
      this.$router.push({ name });
    }
  },
  created() {
    if (this.isClass) {
      this.getData();
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}

.student-content {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 14px;
  text-align: left;
}
</style>
